import React from 'react';
import { connect } from 'react-redux';
import SocialLinks from '../SocialLinks';
import { getTarget } from '../../utils';
import { footerIds } from '../../analyticsTags';
import defaultSonyLogo from '../../images/footer-logo.png';

export const CharSpace = ({ className = '' }: any) => (
  <span className={className}>&nbsp;</span>
);

export const FooterNavButton = ({ title, absolute, external, index }: any) => {
  const width = index > 0 ? 'one-third' : 'full';
  const firstLast = index === 1 ? ' first' : index === 3 ? ' last' : '';

  return (
    <>
      <a
        href={absolute}
        id={footerIds.computed.footerNavButton(title)}
        target={getTarget(external)}
        className={ (footerIds.computed.footerNavButton(title) === "footer_nav_button_Visit SonyPictures.com") ? `btn thin btn-dark uppercase ${width}${firstLast}` : `btn thin btn-dark ${width}${firstLast}`}>
        {title}
      </a>
      <CharSpace className="d-none d-md-inline" />
    </>
  );
};

export const FooterNavLink = ({ title, absolute, external, options }: any) => {

  let onclickevent = '';
  if ("attributes" in options && "onclick" in options.attributes) {
      onclickevent = options.attributes.onclick
  }

  return (
    <>
      <CharSpace />
      <li className="nav-item">
        <a
          href={absolute}
          target={getTarget(external)}
          id={footerIds.computed.footerNavLink(title)}
          onClick={() => {eval(onclickevent)}}
          >
          {title}
        </a>
      </li>
    </>
  );
};

const Footer: React.FC<any> = ({ footer }) => {
  const {
    social,
    buttons,
    links,
    follow_like_block_content,
    copyright_block_content,
    footer_sony_logo,
  } = footer;

  return (
    <footer>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 social-icons">
            <div
              id="block-sociallinks-2"
              className="block block-block-content block-block-content8e09632e-527a-49b8-80e8-39ff34d6611a">
              <div className="content">
                <SocialLinks inFooter links={social} />
              </div>
            </div>
            <div
              id="block-followlinklinks"
              className="block block-block-content block-block-content10262caf-c6ec-4cb0-a398-95f5e8acf2a5">
              <div
    className="content"
    dangerouslySetInnerHTML={{
      __html: follow_like_block_content,
    }}/>
            </div>
          </div>
          <div className="col-12  col-lg-8 offset-lg-2 footer-nav">
            <nav
              role="navigation"
              aria-labelledby="block-footermenu-menu"
              id="block-footermenu"
              className="block block-menu navigation menu--footer-menu">
              <h2 className="sr-only" id="block-footermenu-menu">
                Footer Menu
              </h2>
              <ul className="clearfix nav navbar-nav bd-navbar-nav flex-row">
                {links.length>0?links.map((link: any) => (
                  <FooterNavLink key={link.key} {...link} />
                )):null}
              </ul>
            </nav>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-5 copyright-left">
            <div className="copyright-outer">
              <div
                id="block-footerlogo"
                className="block block-block-content block-block-content35aee9c5-9ce9-4103-806b-70beb54083b4">
                <div className="content">
                  <p>
                    <a href="/" id={footerIds.footerSonyLogo}>
                      <img
                        alt="Logo"
                        data-entity-type="file"
                        data-entity-uuid="a854ba0a-958a-4597-bbab-fc8f87ab08b2"
                        src={footer_sony_logo || defaultSonyLogo}
                      />
                    </a>
                  </p>
                </div>
              </div>
              <div className="copyright">
                <div
                  id="block-copyright"
                  className="block block-block-content block-block-content7a8e5f15-09d8-4633-9911-e4a500cc5a75">
                  <div
    className="content"
    dangerouslySetInnerHTML={{
      __html: copyright_block_content,
    }}/>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-7 text-right copyright-right">
            <nav
              role="navigation"
              aria-labelledby="block-footerrightmenu-menu"
              id="block-footerrightmenu"
              className="block block-menu navigation menu--footer">
              <h2 className="sr-only" id="block-footerrightmenu-menu">
                Footer Right Menu
              </h2>
              {buttons.length>0?buttons.map((data: any, i: number) => (
                <FooterNavButton key={data.key} {...data} index={i} />
              )):null}
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.defaultProps = {
  footer: {
    social: {},
    links: [],
    buttons: [],
  },
};

const mapStateToProps = (state: any) => ({
  footer: state.site.footer,
});

export { Footer };

export default connect(mapStateToProps)(Footer);
